import { WebSocketClient } from './WebSocketClientClass';

const agentWsClient = new WebSocketClient({
  url: process.env.AGENT_CHAT_WS_URL || '',
  connectTimeout: 10_000,
  messageTimeout: 150_000,
  authOrigin: process.env.AUTH_ORIGIN_SERVER_URL,
  unauthorizedRedirectUrl: process.env.UNAUTHORIZED_REDIRECT_URL || '/unauthorized',
});

export { agentWsClient };
